import { render, staticRenderFns } from "./GenericTemplate.vue?vue&type=template&id=484dd6d4&"
import script from "./GenericTemplate.vue?vue&type=script&lang=ts&"
export * from "./GenericTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports